import reduxApi from 'redux-api';
import customFetch from 'api/axios';
import { API_URL } from 'constants/config';

export default reduxApi({
  // Api quản lý danh mục văn bản
  getDanhMucVanBan: {
    url: `${API_URL}/danh-muc-van-ban`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postDanhMucVanBan: {
    url: `${API_URL}/danh-muc-van-ban`,
    options: (url, _params, getState) => {
      return {
        method: 'POST',
        data: _params
      };
    }
  },
  putDanhMucVanBan: {
    url: `${API_URL}/danh-muc-van-ban/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'PUT',
        data: _params
      };
    }
  },
  getChiTietDanhMucVanBan: {
    url: `${API_URL}/danh-muc-van-ban/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  deleteDanhMucVanBan: {
    url: `${API_URL}/danh-muc-van-ban/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE',
        data: _params
      };
    }
  },
  getListDanhMucVanBan: {
    url: `${API_URL}/danh-muc-van-ban/list`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  // Api quản lý loại văn bản
  getLoaiVanBan: {
    url: `${API_URL}/loai-van-ban`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postLoaiVanBan: {
    url: `${API_URL}/loai-van-ban`,
    options: (url, _params, getState) => {
      return {
        method: 'POST',
        data: _params
      };
    }
  },
  putLoaiVanBan: {
    url: `${API_URL}/loai-van-ban/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'PUT',
        data: _params
      };
    }
  },
  deleteLoaiVanBan: {
    url: `${API_URL}/loai-van-ban/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE',
        data: _params
      };
    }
  },

  // Quản lý lĩnh vực văn bản
  getLinhVucVanBan: {
    url: `${API_URL}/linh-vuc-van-ban`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postLinhVucVanBan: {
    url: `${API_URL}/linh-vuc-van-ban`,
    options: (url, _params, getState) => {
      return {
        method: 'POST',
        data: _params
      };
    }
  },
  putLinhVucVanBan: {
    url: `${API_URL}/linh-vuc-van-ban/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'PUT',
        data: _params
      };
    }
  },
  deleteLinhVucVanBan: {
    url: `${API_URL}/linh-vuc-van-ban/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE',
        data: _params
      };
    }
  },

  // Quản lý cơ quan ban hành văn bản
  getCoQuanBanHanhVanBan: {
    url: `${API_URL}/co-quan-ban-hanh`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postCoQuanBanHanhVanBan: {
    url: `${API_URL}/co-quan-ban-hanh`,
    options: (url, _params, getState) => {
      return {
        method: 'POST',
        data: _params
      };
    }
  },
  putCoQuanBanHanhVanBan: {
    url: `${API_URL}/co-quan-ban-hanh/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'PUT',
        data: _params
      };
    }
  },
  deleteCoQuanBanHanhVanBan: {
    url: `${API_URL}/co-quan-ban-hanh/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE',
        data: _params
      };
    }
  },
  // Danh mục nhóm file
  getNhomHoSo: {
    url: `${API_URL}/nhom-ho-so`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postNhomHoSo: {
    url: `${API_URL}/nhom-ho-so`,
    options: (url, _params, getState) => {
      return {
        method: 'POST',
        data: _params
      };
    }
  },
  putNhomHoSo: {
    url: `${API_URL}/nhom-ho-so/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'PUT',
        data: _params
      };
    }
  },
  deleteNhomHoSo: {
    url: `${API_URL}/nhom-ho-so/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE',
        data: _params
      };
    }
  },
  getListNhomHoSo: {
    url: `${API_URL}/nhom-ho-so/list`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  // Api combobox
  getListLoaiVanBan: {
    url: `${API_URL}/loai-van-ban/list`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getListLinhVucVanBan: {
    url: `${API_URL}/linh-vuc-van-ban/list`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getListCoQuanBanHanh: {
    url: `${API_URL}/co-quan-ban-hanh/list`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
}).use('fetch', customFetch);


// WEBPACK FOOTER //
// ./src/api/quanLyVanBan.js